"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var PrivateRoute = function (_a) {
    var component = _a.component, isAuthenticated = _a.isAuthenticated, redirectTo = _a.redirectTo, onFail = _a.onFail, rest = __rest(_a, ["component", "isAuthenticated", "redirectTo", "onFail"]);
    var RenderComponent = component;
    var renderComponent = function (props) {
        if (isAuthenticated) {
            return react_1.default.createElement(RenderComponent, __assign({}, props));
        }
        if (onFail) {
            onFail();
        }
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirectTo || '/login' });
    };
    return react_1.default.createElement(react_router_dom_1.Route, __assign({}, rest, { render: renderComponent }));
};
exports.default = PrivateRoute;
